import { z } from "zod";

import { baseEntityFields } from "./base.js";

/**
 * Rôles d'org (RBAC niveau org, claims minimaux côté Auth).
 * Les rôles fins par app vivent dans Firestore (`/appMemberships`), pas ici.
 */
export const orgRoleSchema = z.enum(["owner", "admin", "member", "viewer"]);

/** Type d'un rôle d'org. */
export type OrgRole = z.infer<typeof orgRoleSchema>;

/**
 * Membre (`member`) : rattachement d'un utilisateur Auth à une org, avec son rôle.
 *
 * Étend les champs standard.
 *
 * - `orgId`       : org de rattachement.
 * - `userId`      : uid Firebase Auth de l'utilisateur.
 * - `email`       : email du membre.
 * - `displayName` : nom affiché, optionnel.
 * - `orgRole`     : rôle au niveau de l'org.
 * - `disabled`    : membre désactivé (accès suspendu).
 */
export const MemberSchema = z.object({
  ...baseEntityFields,
  orgId: z.string(),
  userId: z.string(),
  email: z.string().email(),
  displayName: z.string().optional(),
  orgRole: orgRoleSchema,
  disabled: z.boolean().default(false),
});

/** Type d'un membre. */
export type Member = z.infer<typeof MemberSchema>;
